"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueTypeError = exports.ErrorValueTypeHandler = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class ValueTypeError {
  constructor(code, message, data = null) {
    this.code = code;
    this.message = message;
    this.data = data;
  }
}
exports.ValueTypeError = ValueTypeError;
class ErrorValueTypeHandler {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "error");
  }
  value(val) {
    return null;
  }
  truthy(val) {
    return false;
  }
  equals() {
    return false;
  }
  templateValue(val) {
    return "";
  }
}
exports.ErrorValueTypeHandler = ErrorValueTypeHandler;
//# sourceMappingURL=ErrorValueTypeHandler.js.map